import React from "react";

const AnimalBadge: React.FC = () => (
  <span
    title="Contains animal-derived stock"
    className="inline-flex items-center rounded px-1.5 py-0.5 text-xs font-medium bg-amber-50 text-amber-800 border border-amber-200"
  >
    Animal
  </span>
);

export { AnimalBadge };
